<template>
  <div class="mh bg-main pb90 diplomaWrap">
    <tip
      tips="为保证您的图片正常上传，请将您要上传的证件图片控制在10M以内，若图片过大，上传时请耐心等待！"
    />
    <div class="p10">
      <card-wrap title="最高学历毕业证书">
        <van-uploader
          class="uploader"
          v-model="fileList"
          :max-count="1"
          :after-read="onRead"
          :accept="'image/*'"
          :max-size="10 * 1024 * 1024"
          @oversize="onOversize"
          @delete="deletediploma"
          :disabled="Boolean($route.query.disabled)"
          :deletable="!Boolean($route.query.disabled)" 
        >
          <div class="uploadDemo">
            <div class="showIcon">
              <img src="../../assets/img/xiangji@2x.png" alt="" />
              <div class="mt5">点击上传</div>
            </div>
          </div>
        </van-uploader>
      </card-wrap>
      <card-wrap class="mt8" title="附件要求">
        <div class="tips-wrap mt10 pb10">
          <div>
            建议使用扫描仪或高拍仪，请勿使用屏幕截图。请完整扫描每页材料,保持图片清晰可辨，分辨率在200*200以上，图片大小请控制在10MB以内且为jpg格式。
          </div>
          <div>
            原学历为高中、职高中专技校等同等学历的且原毕业证书丢失的，请上传加盖原毕业学校公章的《毕业证书丢失证明》。
          </div>
        </div>
      </card-wrap>
      <card-wrap class="mt8" title="毕业证书封皮">
        <div class="mt20 pb10 yangli">
          <img src="../../assets/img/yangliCkxl.png" alt="" />
        </div>
      </card-wrap>
      <card-wrap class="mt8" title="毕业证书内芯">
        <div class="mt20 pb10 yangli">
          <img src="../../assets/img/yangliZkxl.png" alt="" />
        </div>
      </card-wrap>
    </div>
    <div class="next">
      <van-button type="info" block class="nextBtn" @click="goBack">返回</van-button>
      <van-button type="info" block class="nextBtn" @click="clickBack" v-if="!Boolean($route.query.disabled)">保存并返回</van-button>
    </div>
  </div>
</template>
<script>
import tip from "./component/tip.vue";
import cardWrap from "./component/cardWrap.vue";
import {uploadPictures,getFileUrl} from "@/api/common/index"// 上传
export default {
  name: "diploma",
  components: { tip,cardWrap },
  data() {
    return {
      fileList: [], // 列表
      preposeDiploma: '', // 前置学历证书
    };
  },
  created() {
    this.preposeDiploma = this.$store.state.preposeDiploma
    if (this.preposeDiploma) { // 有前置学历
      getFileUrl({objectKey: this.preposeDiploma}).then(datas=>{
        this.fileList = [{url: datas}]
      })
    }
  },
  methods: {
    // 删除
    deletediploma() {
      this.preposeDiploma = '' 
    },
    onRead(file) {
      let data = new FormData();
      data.append("files", file.file);
      data.append("token", this.$store.state.token);
      uploadPictures(data).then((res) => {
        this.preposeDiploma = res[0]
        getFileUrl({objectKey: res[0]}).then(datas=>{
          this.fileList = [{url: datas}]
        })

      });
    },
    onOversize() {
      this.$toast.fail("文件大小不能超过 10MB");
    },
    // 点击保存并返回按钮
    clickBack() {
      if (!this.preposeDiploma) {
        this.$toast({
          message: "请上传最高学历毕业证书",
          position: "top",
        });
        return;
      }
      this.$store.commit('setPreposeDiploma', this.preposeDiploma);
      this.$router.back()

    },
    // 返回
    goBack() {
      this.$store.commit('setPreposeDiploma',this.$store.state.preposeDiploma);
      this.$router.back()
    }
  },
};
</script>
<style scoped>
.diplomaWrap {
  box-sizing: border-box;
  padding-bottom: 60px;
}
.uploadDemo {
  background: #faf9f9;
  border: 1px solid #d9d8d8;
  width: 337px;
  height: 225px;
  box-sizing: border-box;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.showIcon {
  font-size: 15px;
  font-weight: 400;
  color: #d62d27;
  line-height: 30px;
  text-align: center;
}
.showIcon img {
  display: block;
  margin: 0 auto;
  width: 20px;
}
.tips-wrap {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  text-align: justify;
}
.tips-wrap span {
  color: #d62d27;
}
.yangli {
  margin-left: 5px;
  margin-right: 5px;
}
.yangli img {
  display: block;
  width: 100%;
}
.uploader /deep/ .van-uploader__preview-image {
  width: 337px;
  height: 225px;
}
.uploader /deep/ .van-uploader__preview-image img {
  width: 337px;
  height: 225px;
}
.uploader {
  position: relative;
}

.next {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  padding: 0 10px;
  background-color: #fff;
}
.next .nextBtn {
  background-color: red;
  border: none;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px;

}

.next .nextBtn:nth-child(1) {
  background-color: #fff;
  border: 1px solid red;
  color: red;
  border-radius: 10px;
  width: 450px;
  margin-right: 10px;
}
</style>